import React from 'react';
import PropTypes from 'prop-types';

import Link from './Link';
import DropdownMenu from './DropdownMenu';
import { isMobile } from '../../../../../services/browser';
import { AsPropType, SiteNavigationLinkPropType } from '../../../../../services/proptypes';
import { groupLinks } from './Links.utils';

const propTypes = {
  links: PropTypes.arrayOf(SiteNavigationLinkPropType).isRequired,
  linksAs: AsPropType,
};

const defaultProps = {
  linksAs: 'span',
};


function Links({ links, linksAs }) {
  const transformedLinks = groupLinks(links);

  if (isMobile()) {
    // First common links, then CTA/button links
    transformedLinks.sort(linkA => linkA.as === 'Button');
  }

  return (
    <>
      {transformedLinks.map(link => {
        if (link.links) {
          return (
            <DropdownMenu
              key={`${link.title}-${link.links.length}`}
              title={link.title}
              options={link.links}
              linksAs={linksAs}
            />
          );
        }
        return <Link key={`${link.title}-${link.url}-${link.slug}`} {...link} />;
      })}
    </>
  );
}

Links.propTypes = propTypes;
Links.defaultProps = defaultProps;

export default Links;
